import { apiFetch } from "./apiClient";

const BASE = "/api/services/route-templates";

export async function getRouteTemplates(filters = {}) {
  const params = new URLSearchParams();
  if (filters.customerId != null) params.set("customer_id", filters.customerId);
  if (filters.locationId != null) params.set("location_id", filters.locationId);
  if (filters.active != null) params.set("active", filters.active);

  const query = params.toString() ? `?${params}` : "";
  const res = await apiFetch(`${BASE}${query}`);
  if (!res.ok) throw new Error("Failed to fetch route templates");
  return res.json();
}

export async function getRouteTemplateById(templateId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.includeInactiveRoutes != null)
    params.set("include_inactive_routes", filters.includeInactiveRoutes);
  if (filters.includeInactiveRooms != null)
    params.set("include_inactive_rooms", filters.includeInactiveRooms);
  const query = params.toString() ? `?${params}` : "";
  const res = await apiFetch(`${BASE}/${templateId}${query}`);
  if (!res.ok) throw new Error("Failed to fetch route template");
  return res.json();
}

export async function getAvailableRooms(templateId) {
  const res = await apiFetch(`${BASE}/${templateId}/available-rooms`);
  if (!res.ok) throw new Error("Failed to fetch available rooms");
  return res.json();
}

export async function createRouteTemplate(payload) {
  const res = await apiFetch(BASE, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to create route template");
  }
  return res.json();
}

export async function createRoute(templateId, payload) {
  const res = await apiFetch(`${BASE}/${templateId}/routes`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to create route");
  }
  return res.json();
}

export async function replaceRouteRooms(routeId, rooms) {
  const res = await apiFetch(`${BASE}/routes/${routeId}/rooms`, {
    method: "PUT",
    body: JSON.stringify({ rooms }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update route rooms");
  }
  return res.json();
}

export async function updateRoute(routeId, payload) {
  const res = await apiFetch(`${BASE}/routes/${routeId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update route");
  }
  return res.json();
}

export async function updateRouteRoom(roomMappingId, payload) {
  const res = await apiFetch(`${BASE}/rooms/${roomMappingId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update route room");
  }
  return res.json();
}

export async function syncRouteTemplateFutureJobs(templateId, payload = {}) {
  const res = await apiFetch(`${BASE}/${templateId}/sync-future-jobs`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(
      err.error || "Failed to sync future jobs for route template",
    );
  }

  return res.json();
}
